import React, { useEffect, useState, useRef } from "react";
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Container,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import showNotification from "../../helpers/show_notification";
import { postSubmitForm } from "../../helpers/forms_helper";
import { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import exportFromJSON from "export-from-json";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import printDiv from "../../helpers/print_data";

const BranchCategory = (props) => {
  const { SearchBar } = Search;
  useEffect(() => {
    loadAllBranchCategories();
  }, []);

  const [allBranchCategories, setAllBranchcategories] = useState([]);
  const loadAllBranchCategories = async () => {
    let url = process.env.REACT_APP_BASEURL + "branchcategories/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllBranchcategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  const refContainer = useRef(null);
  const [isLoading, setIsLoading] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      setIsLoading(true)
      let url = process.env.REACT_APP_BASEURL + "branchcategories/insert";
      let response = await postSubmitForm(url, v);
      if (response.status === 1) {
        loadAllBranchCategories();
        showNotification(response.message, "Success");
        refContainer.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }finally{
      setIsLoading(false)
    }
  };
  const handleValidUpdate = async (e, v) => {
    try {
      const object = {
        id: selectedRow._id,
        name: v.name,
      };
      setIsLoading(true)
      let url = process.env.REACT_APP_BASEURL + "branchcategories/update";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllBranchCategories();
        setEditModal(false);
        showNotification(response.message, "Success");
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally{
      setIsLoading(false)
    }
  };

  const [selectedRow, setSelecetedRow] = useState();
  const [editModal, setEditModal] = useState();
   const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "1%" };
      },
    },
    {
      text: props.t("Branch Category Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "16%" };
      },
    },
    {
      text: props.t("Action"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <span className="text-info">
            <i
              className="bx bxs-edit font-size-15"
              title="Click to Edit"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setEditModal(!editModal);
                setSelecetedRow(row);
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];
 const handleDownload = async () => {
    const fileName = "All Branch Categories";
    const exportType = "xls";

    let data_to_export = allBranchCategories;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          Name: v.name,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Branch Category")}
            breadcrumbItem={props.t("Add/Update Branch Category")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleValidSubmit} ref={refContainer}>
                    <CardTitle>{props.t("Add Branch Category")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t("Enter the following details to add a new branch category")}
                    </CardSubtitle>
                    <Row>
                      <Col lg={4} md={4}>
                        <AvField
                          name="name"
                          label={props.t("Branch Category")}
                          placeholder={props.t("Enter category name")}
                          type="text"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: props.t("Name cannot be empty"),
                            },
                          }}
                        />
                      </Col>
                      

                      <Col lg={8} md={8}>
                        <div className="mt-4 ">
                            <Button type="submit" disabled={isLoading} style={{width:"100px"}} color="primary">
                              {isLoading ? <Spinner size="sm"/> : props.t("Submit")}
                            </Button>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("All Branch Categories")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t( "View/Update all your existing branch categories here")}
                  </CardSubtitle>

                  <Row className="mb-2">
                    
                  </Row>

                  <div id="Branch Categories">
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allBranchCategories && allBranchCategories}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(tprops) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...tprops.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4} className="text-center">
                              <CardTitle>All Branch Categories</CardTitle>
                            </Col>
                            <Col lg="4" className="text-right">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"  "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("Branch Categories");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...tprops.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  <Modal
                    size="lg"
                    isOpen={editModal}
                    toggle={() => setEditModal(!editModal)}
                  >
                    <ModalHeader toggle={() => setEditModal(!editModal)}>
                      {props.t("Update Branch Category")}
                    </ModalHeader>
                    <ModalBody>
                      {selectedRow && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <AvForm onValidSubmit={handleValidUpdate}>
                                    <Row>
                                      <Col lg={6}>
                                        <AvField
                                          name="name"
                                          value={selectedRow.name}
                                          label={props.t("Branch Category")}
                                          placeholder={props.t(
                                            "Enter Category Name"
                                          )}
                                          type="text"
                                          validate={{
                                            required: {
                                              value: true,
                                              errorMessage: props.t(
                                                "Name cannot be empty"
                                              ),
                                            },
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg={12}>
                                        <hr />
                                        <FormGroup className="mb-0 text-center">
                                          <div>
                                            <Button
                                              type="submit"
                                              color="primary"
                                              disabled={isLoading}
                                              style={{width:"100px"}}
                                            >
                                              {isLoading ? <Spinner size={"sm"}/> :props.t("Update")}
                                            </Button>
                                          </div>
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </AvForm>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(connect(null, {})(withNamespaces()(BranchCategory)));
